import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class Poi extends ApiCore {
  constructor(store) {
    const path = `${PUBLIC}/supported/order/poi`
    super(store, path)
  }

  supportedPoiList(filter, showProgress) {
    return this.request({
      action: 'list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
